function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { SIcon } from "./components";
const SInputV2 = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { className, borderless = false, iconType, styleless } = _param, props = _object_without_properties(_param, [
        "className",
        "borderless",
        "iconType",
        "styleless"
    ]);
    const baseStyles = "appearance-none w-full px-3 !text-[13px]";
    const borderClassStyles = borderless ? "border-none focus:border-none focus:ring-0 focus:outline-none transition" : "!bg-grayscale-dark !h-[32px] rounded-md border-white/10 focus:border-white/30 focus:ring-0 focus:outline-none transition";
    const disabledClassStyles = props.disabled ? "text-white/50 cursor-not-allowed" : "";
    const input = /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        className: styleless ? className : `${baseStyles} ${borderClassStyles} ${disabledClassStyles} ${className}`
    }));
    return iconType ? /*#__PURE__*/ _jsxs("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({
                ref: ref
            }, props), {
                className: `${baseStyles} ${borderClassStyles} ${className} !pr-10`
            })),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute right-[9px] z-10 top-[9px] bottom-[9px] transform flex flex-row items-center justify-center pl-[9px] border-l border-white/10",
                children: /*#__PURE__*/ _jsx(SIcon, {
                    size: 12,
                    className: "opacity-50",
                    type: iconType
                })
            })
        ]
    }) : input;
});
export { SInputV2 };
